module.exports = __webpack_public_path__ + "static/media/noPresenterImage.4ff9ccb4.svg";